// extracted by mini-css-extract-plugin
export var alternate = "_e-j";
export var black = "_e-6";
export var blue = "_e-f";
export var blueLight = "_e-e";
export var brand = "_e-8";
export var darkMode = "_e-b";
export var error = "_e-a";
export var gray = "_e-5";
export var grayBlue = "_e-d";
export var iconWrapper = "_e-3";
export var inactive = "_e-7";
export var indigo = "_e-g";
export var orange = "_e-i";
export var pink = "_e-h";
export var primary = "_e-0";
export var purple = "_e-9";
export var success = "_e-4";
export var warning = "_e-c";
export var white = "_e-1";
export var whiteSuccess = "_e-2";